<script lang="ts">
  import { slide } from 'svelte/transition'
  import type { Snippet } from 'svelte'

  type Props = {
    children?: Snippet
  }

  let { children }: Props = $props()
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<!-- svelte-ignore a11y_click_events_have_key_events -->
<div
  class="gap-4 flex justify-end px-3 h-7 w-full relative"
  onclick={(e) => e.stopPropagation()}
>
  {@render children?.()}
</div>
